import Header from "./Header";
import Footer from "./Footer";
import SideBar from "./SideBar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SessionOut from "./SessionOut";
import GoToTop from "./GoToTop";
const Layout = ({ children, logoutHandler }) => {
  return (
    <div className="parent">
      <Header logoutHandler={logoutHandler} />
      <div className="main">
        <SideBar logoutHandler={logoutHandler} />
        <div className="home">{children}</div>
      </div>
      <Footer />
      <SessionOut />
      <GoToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default Layout;
